import { parseTimeIntoSeconds } from '@studio/helpers/unitConversion/parseTimeIntoSeconds';

const calculateVideoDuration = (startPosition: string, stopPosition: string): number | null => {
  let duration = null;
  if (stopPosition) {
    const stopPosInSec = parseTimeIntoSeconds(stopPosition);
    if (startPosition) {
      const startPosInSec = startPosition === '' ? 0 : parseTimeIntoSeconds(startPosition);
      duration = stopPosInSec - startPosInSec;
    } else {
      duration = stopPosInSec;
    }
  }
  return duration;
};

export default calculateVideoDuration;
